import { useState } from "react";
import Topbar from "./Topbar";
import Sidebar from "./Sidebar";
import Statusbar from "./Statusbar";
import StorageBanner from "./StorageBanner";
import useTheme from "../../hooks/useTheme";

interface Product {
  id: number;
  name: string;
  updated_at?: string;
}

interface AppShellProps {
  children: React.ReactNode;
  productName?: string;
  products?: Product[];
  currentProductId?: number;
  activeStep?: string;
  onStepClick?: (step: string) => void;
  rightPanel?: React.ReactNode;
  statusProps?: {
    status?: string;
    jobId?: number;
    modelName?: string;
    runningCount?: number;
    totalCount?: number;
  };
  user?: { name: string; initials: string; role?: string; credits_used?: number; credits_total?: number };
  progress?: number;
}

export default function AppShell({
  children,
  productName,
  products,
  currentProductId,
  activeStep,
  onStepClick,
  rightPanel,
  statusProps,
  user,
  progress,
}: AppShellProps) {
  const { theme, toggle: toggleTheme } = useTheme();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const hasRightPanel = !!rightPanel;
  const sidebarWidth = sidebarCollapsed ? "0" : "240px";
  const gridCols = `${sidebarWidth} 1fr${hasRightPanel ? " 360px" : ""}`;

  return (
    <div className={`app${sidebarCollapsed ? " sidebar-hidden" : ""}`} style={{ gridTemplateColumns: gridCols }}>
      <Topbar
        theme={theme}
        toggleTheme={toggleTheme}
        productName={productName}
        progress={progress}
        sidebarCollapsed={sidebarCollapsed}
        onToggleSidebar={() => setSidebarCollapsed((c) => !c)}
      />
      <Sidebar
        products={products}
        currentProductId={currentProductId}
        activeStep={activeStep}
        onStepClick={onStepClick}
        user={user}
      />
      <div className="main">
        <div className="scroll-area">
          <StorageBanner />
          {children}
        </div>
      </div>
      {hasRightPanel && rightPanel}
      <Statusbar {...statusProps} />
    </div>
  );
}
